// TODO: Use skeleton component

export const CheckCurrencySkeleton: React.FC = () => {
  return (
    <svg
      width="335"
      height="270"
      viewBox="0 0 335 270"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5445_66810"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="335"
        height="270"
      >
        <rect width="335" height="270" fill="#D54A4A" />
      </mask>
      <g mask="url(#mask0_5445_66810)">
        <circle opacity="0.34" cx="164" cy="45" r="45" fill="#343434" />
        <circle cx="199.5" cy="74.5" r="15.5" fill="#343434" />
        <rect
          opacity="0.34"
          x="110"
          y="109"
          width="116"
          height="12"
          rx="3"
          fill="white"
          fillOpacity="0.24"
        />
        <rect
          opacity="0.34"
          x="150"
          y="131"
          width="35"
          height="12"
          rx="3"
          fill="white"
          fillOpacity="0.24"
        />
        <rect
          opacity="0.34"
          x="83"
          y="149"
          width="170"
          height="12"
          rx="3"
          fill="white"
          fillOpacity="0.24"
        />
        <rect
          opacity="0.34"
          x="41"
          y="174"
          width="253"
          height="31"
          rx="6"
          fill="white"
          fillOpacity="0.24"
        />
        <rect
          opacity="0.34"
          x="52"
          y="184"
          width="200"
          height="12"
          rx="4"
          fill="#D9D9D9"
          fillOpacity="0.39"
        />
        <rect
          opacity="0.34"
          y="226"
          width="335"
          height="44"
          rx="8"
          fill="white"
          fillOpacity="0.24"
        />
        <rect
          opacity="0.34"
          x="39"
          y="242"
          width="257"
          height="12"
          rx="4"
          fill="#D9D9D9"
          fillOpacity="0.39"
        />
        <rect
          opacity="0.34"
          x="267"
          y="184"
          width="13"
          height="12"
          rx="4"
          fill="#D9D9D9"
          fillOpacity="0.39"
        />
      </g>
    </svg>
  )
}
